import api from '../../services/serviceBase'
import {queryOldDashboard} from '../../util/OldDashboardLink.js'
import store from '../../store'

export default {
    createNewPractice(practice) {
        return api.execute('post', `/Practice/InsertNewPractice?practice=${practice}`)
    },

    getCurrentPractice(practiceCode) {
        return api.execute('get', `/Practice/Practice?practiceCode=${practiceCode}`)
    },

    updatePractice(practice) {
        return api.execute('post', `/Practice/UpdatePractice`, practice)
    },
    getMasterPractice(domain){
        return api.execute('get', `/Practice/MasterPractice?domain=${domain}`)
    },
    getAccountsCreatedForPracticeByDateOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser){
        return api.execute('get', `/Practice/AccountsCreatedMetricsSeries?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    getActiveAccountsForPracticeByDateOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser){
        return api.execute('get', `/Practice/ActiveParticipantsMetricsSeries?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    getInactiveAccountsForPracticeByDateOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser){
        return api.execute('get', `/Practice/InactiveParticipantsMetricsSeries?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    GetLoginsForPracticeByDateOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser){
        return api.execute('get', `/Practice/LoginsMetricsSeries?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    GetEngagementScoreAverageForPractice(practice, queryingUser){
        return api.execute('get', `/Practice/EngagementScoreAverageMetrics?practiceCode=${practice}&queryingUser=${queryingUser}`)
    },
    GetEngagementScoreAverageForPracticeByDateOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser){
        return api.execute('get', `/Practice/EngagementScoreAverageMetricsByDate?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    GetEngagementScoresForPractice(practice, queryingUser){
        return api.execute('get', `/Practice/EngagementScoreMetrics?practiceCode=${practice}&queryingUser=${queryingUser}`)
    },
    GetEngagementScoreByActiveUsersForPracticeOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser) {
        return api.execute('get', `/Practice/EngagementScoreByActiveUsersForPracticeSummary?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    getActiveParticipants(practice, queryingUser) {
        return api.execute('get', `/Practice/ActiveParticipants?practiceCode=${practice}&queryingUser=${queryingUser}`)
    },
    getInactiveParticipants(practice, queryingUser) {
        return api.execute('get', `/Practice/InactiveParticipants?practiceCode=${practice}&queryingUser=${queryingUser}`)
    },
    getActiveUsersByPractice(practice, queryingUser) {
        return api.execute('get', `/Practice/ActiveUsers?practiceCode=${practice}&queryingUser=${queryingUser}`)
    },
    getInactiveUsersByPractice(practice, queryingUser) {
        return api.execute('get', `/Practice/InactiveUsers?practiceCode=${practice}&queryingUser=${queryingUser}`)
    },
    getCustomers(practice) {
        return api.execute('get', `/Practice/Customers?practiceCode=${practice}`)
    },
    getSurveysByPractice(practice) {
        return api.execute('get', `/Practice/Surveys?practiceCode=${practice}`)
    },
    getNumberOfActiveParticipants(practice, queryingUser){
        return api.execute('get', `/Practice/NumberOfActiveParticipantsMetric?practiceCode=${practice}&queryingUser=${queryingUser}`)
    },
    getNumberOfInactiveParticipants(practice, queryingUser){
        return api.execute('get', `/Practice/NumberOfInactiveParticipantsMetric?practiceCode=${practice}&queryingUser=${queryingUser}`)
    },
    getNumberOfCustomers(practice){
        return api.execute('get', `/Practice/NumberOfCustomersMetric?practiceCode=${practice}`)
    },
    sendMessageToListOfUsers(users, from, replyTo, deliveryType, subject, content) {
        var parameters = {
            logins: users.toString(),
            messageFrom: from,
            messageReplyTo: replyTo,
            messageDeliveryType: deliveryType,
            messageSubject: subject,
            messageBody: content,
            app: 'true'
        }
        queryOldDashboard(`..//home/admin/queries/action_send_message.asp`, parameters)
    },
    GetDaysLoggedInByActiveUsersForPracticeOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser) {
        return api.execute('get', `/Practice/DaysLoggedInByActiveUsersForPracticeSummary?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    LoadComponentsList(practice,login){
        return api.execute('get',`/Practice/ComponentList?practiceCode=${practice}&login=${login}`)
    },
    GetWeightSummaries(practice, queryingUser) {
        return api.execute('get', `/Practice/WeightLossMetricsSummary?practiceCode=${practice}&queryingUser=${queryingUser}`)
    },
    GetWeightChangesOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser) {
        return api.execute('get', `/Practice/WeightChangesSummary?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    GetCalendarColorSumsOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser){
        return api.execute('get', `/Practice/CalendarColorSummary?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    GetCalendarColorSumsByDateOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser){
        return api.execute('get', `/Practice/CalendarColorSeries?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    GetCalendarColorSumsByUserOverDateRange(practice, dateRangeStart, dateRangeEnd, queryingUser){
        return api.execute('get', `/Practice/CalendarColorUserSummary?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    GetNumberOfScaleReadingsByUserOverDateRange(practice, dateRangeStart, dateRangeEnd){
        return api.execute('get', `/Practice/NumberOfScaleReadingsByUser?practiceCode=${practice}&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}`)
    },
    uploadPracticeLogo (fileData) {
        return api.execute('post', `/Practice/uploadPracticeLogo`, fileData);
    },
    GetAveragePatientInteractionScoreMetricSeries(practice, dateRangeStart, dateRangeEnd, queryingUser){
        return api.execute('get', `/Practice/AveragePatientInteractionScoresMetricSeries?practiceCode=${practice}&startDate=${dateRangeStart}&endDate=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    GetPatientInteractionScores(practice, dateRangeStart, dateRangeEnd, queryingUser){
        return api.execute('get', `/Practice/PatientInteractionScores?practiceCode=${practice}&startDate=${dateRangeStart}&endDate=${dateRangeEnd}&queryingUser=${queryingUser}`)
    },
    getpracticeLogo (practiceCode) {
        return api.execute('get', `/Practice/PracticeLogo?practiceCode=${practiceCode}`);
    },
}